import {User} from './user.model';
import {UserAuthData} from "./user-auth-data.model";
import {VetClinicStartContextData} from "./vet-clinic-start-context-data.model";

/**
 * Model odpowiedzi serwera (DTO) po pomyślnym uwierzytelnieniu użytkownika (Logowaniu).
 * Stanowi kompleksową paczkę danych startowych, niezbędną do zainicjowania
 * sesji i wyrenderowania interfejsu Dashboardu zgodnie z uprawnieniami.
 */
export class UserSigninResponse {

  /** Główny obiekt zalogowanego pracownika.
   * Zawiera podstawowe dane profilowe, takie jak imię, nazwisko, czy adres e-mail,
   * które są wyświetlane w nagłówku aplikacji.
   */
  public user: User;

  /** Dane autoryzacyjne sesji.
   * Przechowuje token dostępowy oraz surowe informacje o przypisanych
   * rolach bezpieczeństwa, które determinują dostęp do widoków.
   */
  public userAuthData: UserAuthData;

  /** Kontekst startowy kliniki (Bootstrap Context).
   * Niezwykle ważny obiekt w systemach wielodostępnych (Multi-tenant).
   * Dostarcza frontendowi natychmiastową informację o tym, w kontekście której
   * placówki pracuje dany użytkownik.
   */
  public vetClinicStartContextData: VetClinicStartContextData

  constructor() {
  }
}
